import { ResidentDirectoryItem } from '../types';

export const INITIAL_RESIDENTS: ResidentDirectoryItem[] = [
  {
    id: 'res-88-01',
    house_number: '88/01',
    owner_name: 'คุณกิตติศักดิ์ บุญเรือง',
    resident_type: 'owner',
    phone: '081-999-1111',
    email: 'kittisak.b@gmail.com',
    line_id: 'kittisak_b',
    house_type: 'บ้านเดี่ยว 2 ชั้น (Type A Grande)',
    land_size_sqw: 78.5,
    vehicles: [
      { license_plate: '1กข-9921 กทม.', brand_color: 'Toyota Camry (สีขาวมุก)', type: 'car' },
      { license_plate: '5ขค-3310 กทม.', brand_color: 'Honda CR-V (สีดำ)', type: 'car' },
    ],
    family_members_count: 4,
    pets_count: 1,
    common_fee_status: 'paid',
    outstanding_amount: 0,
    move_in_date: '2024-03-15',
    notes: 'ชำระค่าส่วนกลางล่วงหน้ารายปีสม่ำเสมอ เป็นตัวแทนโซนซอย 1',
    emergency_contact: { name: 'คุณวิมลรัตน์ (ภรรยา)', phone: '081-999-1112', relation: 'ภรรยา' },
  },
  {
    id: 'res-88-05',
    house_number: '88/05',
    owner_name: 'คุณวิภาดา สถิตย์',
    resident_type: 'owner',
    phone: '086-555-2222',
    email: 'vipada.s@yahoo.com',
    line_id: 'vipada_home',
    house_type: 'บ้านเดี่ยว 2 ชั้น (Type B Luxe)',
    land_size_sqw: 65.0,
    vehicles: [
      { license_plate: '4กต-5812 กทม.', brand_color: 'Benz C200 (สีบรอนซ์เงิน)', type: 'car' },
    ],
    family_members_count: 3,
    pets_count: 2,
    common_fee_status: 'pending_verification',
    outstanding_amount: 1800,
    move_in_date: '2024-05-20',
    notes: 'แนบสลิปชำระงวด ส.ค. 2569 แล้ว รอนิติบุคคลกดยืนยัน',
    emergency_contact: { name: 'คุณธวัชชัย สถิตย์', phone: '086-555-2223', relation: 'สามี' },
  },
  {
    id: 'res-88-09',
    house_number: '88/09',
    owner_name: 'คุณชลธิชา เจริญชัย',
    resident_type: 'owner',
    phone: '089-333-4444',
    email: 'chonthicha.c@outlook.com',
    line_id: 'chon_elegance',
    house_type: 'บ้านแฝดพรีเมียม (Type Twin Elegance)',
    land_size_sqw: 42.0,
    vehicles: [
      { license_plate: '9กว-1422 กทม.', brand_color: 'Mazda CX-30 (สีแดง Soul Red)', type: 'car' },
      { license_plate: '1กพ-8833 กทม.', brand_color: 'Vespa Sprint 150 (สีเหลือง)', type: 'motorcycle' },
    ],
    family_members_count: 2,
    pets_count: 1,
    common_fee_status: 'paid',
    outstanding_amount: 0,
    move_in_date: '2024-06-01',
    notes: 'ขอสติกเกอร์เข้า-ออกประตู Easy Pass เพิ่มเติม 1 ใบ',
    emergency_contact: { name: 'คุณนรินทร์ เจริญชัย', phone: '089-333-4445', relation: 'พี่ชาย' },
  },
  {
    id: 'res-88-12',
    house_number: '88/12',
    owner_name: 'คุณอนุกูล พรหมดี',
    resident_type: 'owner',
    phone: '081-234-5678',
    email: 'anukun.tack@gmail.com',
    line_id: 'anukun_narawadee',
    house_type: 'บ้านเดี่ยวหลังมุม (Type A Corner Master)',
    land_size_sqw: 85.2,
    vehicles: [
      { license_plate: '7กก-8812 กทม.', brand_color: 'BMW Series 5 (สีดำ Carbon Black)', type: 'car' },
      { license_plate: '2ขพ-1288 กทม.', brand_color: 'Honda Accord e:HEV (สีขาวมุก)', type: 'car' },
      { license_plate: '1กข-8812 กทม.', brand_color: 'Yamaha XMAX (สีเทาแลมโบ)', type: 'motorcycle' },
    ],
    family_members_count: 4,
    pets_count: 2,
    common_fee_status: 'unpaid',
    outstanding_amount: 1500,
    move_in_date: '2023-12-01',
    notes: 'กรรมการหมู่บ้าน ฝ่ายความปลอดภัยและเทคโนโลยีสารสนเทศ',
    emergency_contact: { name: 'คุณพิมพ์ใจ พรหมดี', phone: '081-234-5679', relation: 'คู่สมรส' },
  },
  {
    id: 'res-88-20',
    house_number: '88/20',
    owner_name: 'คุณประดิษฐ์ มั่นคง',
    resident_type: 'owner',
    phone: '084-777-8888',
    email: 'pradit.m@gmail.com',
    house_type: 'บ้านเดี่ยว 2 ชั้น (Type B Luxe)',
    land_size_sqw: 62.0,
    vehicles: [
      { license_plate: '6ขย-3901 กทม.', brand_color: 'Isuzu MU-X (สีเทา)', type: 'car' },
    ],
    family_members_count: 3,
    pets_count: 0,
    common_fee_status: 'overdue',
    outstanding_amount: 3000,
    move_in_date: '2024-01-15',
    notes: 'ค้างชำระค่าส่วนกลาง 2 งวด (ก.ค. และ ส.ค. 2569) นิติได้ส่งจดหมายแจ้งเตือนครั้งที่ 1 แล้ว',
    emergency_contact: { name: 'คุณสมศรี มั่นคง', phone: '084-777-8889', relation: 'พี่สาว' },
  },
  {
    id: 'res-88-24',
    house_number: '88/24',
    owner_name: 'คุณสมชาย วิจิตรศิลป์',
    resident_type: 'tenant',
    phone: '082-111-9999',
    email: 'somchai.art@hotmail.com',
    line_id: 'somchai_art',
    house_type: 'บ้านเดี่ยว 2 ชั้น (Type A Grande)',
    land_size_sqw: 70.0,
    vehicles: [
      { license_plate: '3กม-7744 กทม.', brand_color: 'Toyota Fortuner (สีดำ)', type: 'car' },
    ],
    family_members_count: 2,
    pets_count: 1,
    common_fee_status: 'paid',
    outstanding_amount: 0,
    move_in_date: '2024-04-01',
    notes: 'ผู้เช่าระยะยาว สัญญาเช่าถึง 31 มี.ค. 2570 (เจ้าของเดิม: พล.อ. สมเกียรติ)',
    emergency_contact: { name: 'คุณสุชาดา วิจิตรศิลป์', phone: '082-111-9998', relation: 'บุตรสาว' },
  },
  {
    id: 'res-88-33',
    house_number: '88/33',
    owner_name: 'พญ. พรพิมล กาญจนกิจ',
    resident_type: 'owner',
    phone: '087-444-5555',
    email: 'dr.pornpimon@hospital.ac.th',
    house_type: 'บ้านเดี่ยวหลังมุม (Type A Corner Master)',
    land_size_sqw: 92.0,
    vehicles: [
      { license_plate: '8กฮ-5533 กทม.', brand_color: 'Volvo XC90 Recharge (สีขาว)', type: 'car' },
    ],
    family_members_count: 2,
    pets_count: 0,
    common_fee_status: 'paid',
    outstanding_amount: 0,
    move_in_date: '2024-02-10',
    notes: 'แพทย์ประจำรพ. กลับบ้านดึกช่วงเวรฉุกเฉิน นิติประสาน รปภ. อำนวยความสะดวก',
    emergency_contact: { name: 'นพ. วรวัฒน์ กาญจนกิจ', phone: '087-444-5556', relation: 'สามี' },
  },
  {
    id: 'res-88-45',
    house_number: '88/45',
    owner_name: 'คุณภาณุวัฒน์ เด่นสกุล',
    resident_type: 'owner',
    phone: '083-666-7788',
    email: 'panuwat.d@techcorp.co.th',
    line_id: 'panuwat_d',
    house_type: 'บ้านแฝดพรีเมียม (Type Twin Elegance)',
    land_size_sqw: 45.0,
    vehicles: [
      { license_plate: '1ขต-4455 กทม.', brand_color: 'Tesla Model Y (สีเทา Stealth Grey)', type: 'car' },
    ],
    family_members_count: 3,
    pets_count: 1,
    common_fee_status: 'paid',
    outstanding_amount: 0,
    move_in_date: '2024-07-01',
    notes: 'ติดตั้ง EV Charger 22kW ได้รับอนุญาตจากนิติบุคคลแล้ว',
    emergency_contact: { name: 'คุณศศิธร เด่นสกุล', phone: '083-666-7789', relation: 'ภรรยา' },
  },
];
